import { makeStyles } from 'tss-react/mui';
import { SUGGESTED_PRODUCTS_COLUMN_GAP } from './hooks/useSuggestedProductsColumns';

const SUGGESTED_PRODUCTS_CARD_WIDTH = 139;

interface SuggestedProductsStylesParams {
  columns: number;
}

export const useSuggestedProductsStyles = makeStyles<SuggestedProductsStylesParams>()(
  (theme, { columns }) => ({
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: theme.spacing(1.5),
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
      gap: SUGGESTED_PRODUCTS_COLUMN_GAP,
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        marginInline: theme.spacing(-2),
        paddingInline: theme.spacing(2),
        overflowX: 'auto',
        overflowY: 'hidden',
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
    card: {
      position: 'relative',
      display: 'flex',
      minWidth: 0,
      borderRadius: theme.shape.borderRadiusMd,
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 auto',
        width: SUGGESTED_PRODUCTS_CARD_WIDTH,
      },
    },
    loadMoreSentinel: {
      gridColumn: '1 / -1',
      width: '100%',
      height: 1,
      [theme.breakpoints.down('lg')]: {
        flex: '0 0 auto',
        width: 1,
        height: 'auto',
      },
    },
    emptyState: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingBlock: theme.spacing(3),
    },
  }),
);
